<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <!-- <changeLanguageHeaderTable @change-language="changeLanguage" :current-language="currentLanguage" /> -->
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import '@/components/change-language-header-table.vue'
import RedirectSettingsList from './useRedirectSettingsList'

export default {
  name: 'RedirectSettingsList',
  components: {
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      errorManager,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = RedirectSettingsList()
    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      errorManager,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
}
</script>
